import React from 'react';
import { Link } from 'react-router-dom';
import '../../stylesheets/stylesLayout/contact.scss';
import routes from '../../utils/commonVariables/routes';
import Card from '../../muiComponents/Card';
import useTranslate from '../../customHooks/useTranslate';

const LandingContact = () => {
    const translate = useTranslate();

    return (
        <main className='flex-center margin20'>
            <div className='contact-page'>
                <h1 className='header-title-contact'>
                    {translate('contact_US')}
                </h1>
                <div className=''>
                    <ul className='flex-center gap-30 margin-10'>
                        <div>
                            <li className='  contact-us-li'>
                                <Link
                                    to={`${routes.contact}/contact-form`}
                                    className='aside__item-link-contact '
                                >
                                    {translate('contact_form')}
                                </Link>
                            </li>
                        </div>
                        <li className='  contact-us-li'>
                            <Link
                                to={routes.serviceDesk}
                                className='aside__item-link-contact '
                            >
                                {translate('property_service_desk')}
                            </Link>
                        </li>
                    </ul>
                    <div className='flex-center gap-20'>
                        <div className='flex-column flex-grow gap-20'>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('partner_services')}
                                </div>
                                <div className=''>
                                    <p className=''>+34 971 416 770 Ext.2</p>
                                    <p className=''>
                                        {' '}
                                        partners@fastpayhotels.com
                                    </p>
                                </div>
                            </Card>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('finance_invoicing')}
                                </div>
                                <div className=''>
                                    <p className=''>+34 971 416 770 Ext.1</p>
                                    <p className=''>
                                        accounts@fastpayhotels.com
                                    </p>
                                </div>
                            </Card>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('connectivity')}
                                </div>
                                <div className=''>
                                    <p className=''>+34 971 416 770 Ext.3</p>
                                    <p className=''>
                                        connectivity@fastpayhotels.com
                                    </p>
                                </div>
                            </Card>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('talent_culture')}
                                </div>
                                <div className=''>
                                    <p className=''>hr@fastpayhotels.com</p>
                                </div>
                            </Card>
                        </div>
                        <div className='flex-column flex-grow gap-20'>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('supply_partners_payments')}
                                </div>
                                <div className=''>
                                    <p className=''>+34 518 888 959</p>
                                    <p className=''>
                                        {' '}
                                        supplierpayments@fastpayhotels.com
                                    </p>
                                </div>
                            </Card>
                            <Card className='padding20 flex-column gap-10'>
                                <div className='contact-card__title'>
                                    {translate('service_desk')}
                                </div>
                                <div className='flex-column gap-5'>
                                    <p>
                                        <span className='font-weight-b '>
                                            Spain
                                        </span>{' '}
                                        +34 518 899 100
                                    </p>
                                    <p>
                                        <span className='font-weight-b '>
                                            Brazil
                                        </span>{' '}
                                        +55 513 376 9316
                                    </p>
                                    <p>
                                        <span className='font-weight-b '>
                                            United Kingdom
                                        </span>{' '}
                                        +44 143 190 5054
                                    </p>
                                    <p>
                                        <span className='font-weight-b '>
                                            United States
                                        </span>{' '}
                                        +1 518 897 3222
                                    </p>
                                    <p>
                                        <span className='font-weight-b '>
                                            Austria
                                        </span>{' '}
                                        +43 720 115 136
                                    </p>
                                    <p>
                                        <span className='font-weight-b '>
                                            Emergency 24/7
                                        </span>{' '}
                                        +34 616 250 672
                                    </p>
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default LandingContact;
